import React from "react";

const SvgBirdWhite = props => (
  <svg viewBox="0 0 43.48 25.27" {...props}>
    <defs>
      <style>{".Bird_white_svg__cls-1{fill:#fff}"}</style>
    </defs>
    <g id="Bird_white_svg__Vrstva_2" data-name="Vrstva 2">
      <g id="Bird_white_svg__Vrstva_1-2" data-name="Vrstva 1">
        <g id="Bird_white_svg__Vrstva_2-2" data-name="Vrstva 2">
          <g id="Bird_white_svg__Livello_1" data-name="Livello 1">
            <path
              className="Bird_white_svg__cls-1"
              d="M21.77 12.15c3.79-1.3 5.36-2 7.45.23a16.7 16.7 0 013.15 5.12 13.8 13.8 0 01-4.71 2.86 25 25 0 01-4.27 1s.57-2 1.17-3.69S27 12.15 27 12.15l-1.85-.21a37.64 37.64 0 00-3.85 6.87 43.36 43.36 0 00-2.07 6.46 72.15 72.15 0 0010.61-2c3.85-1.27 6.74-2.39 7.48-3.27s2.12-2.78 3-7.85a13.9 13.9 0 00-.58-7.34s-.49-.23-2.5.66a8.17 8.17 0 00-1 .55 7.76 7.76 0 00-2 1.83 8.37 8.37 0 01.76 5.41c-2.23-3.39-4.21-5.18-6-5.8-2.66-.88-4.05-.44-9.44 2-4.69 2.12-13.32 7.15-17.7 9.86L0 20.44s17.7-6.89 21.77-8.29z"
            />
            <path
              className="Bird_white_svg__cls-1"
              d="M30.46 6.94A20.79 20.79 0 0135 3.69 68.56 68.56 0 0143.48 0a43.43 43.43 0 00-9.58 3.36 29.9 29.9 0 00-4.72 3.16z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgBirdWhite;

